export const NEWSFEED_BACKGROUND_MAX_CHARS = 90;

function stripExt(name) {
  return String(name || '').replace(/\.[^.]+$/i, '');
}

function normalizeSlug(name, prefix) {
  return stripExt(String(name || ''))
    .replace(new RegExp('^' + String(prefix || '')), '')
    .replace(/saftey/gi, 'safety')
    .toLowerCase();
}

function toPairMap(list, prefix) {
  const map = new Map();
  (Array.isArray(list) ? list : []).forEach((item) => {
    if (!item || !item.file || !item.url) return;
    const rawUrl = item.url;
    const normalizedUrl =
      rawUrl && typeof rawUrl === 'object' && typeof rawUrl.default === 'string'
        ? rawUrl.default
        : String(rawUrl || '');
    if (!normalizedUrl) return;
    map.set(normalizeSlug(item.file, prefix), normalizedUrl);
  });
  return map;
}

function buildGroup(cfg) {
  const selectorBySlug = toPairMap(cfg.selectorItems, cfg.selectorPrefix);
  const backgroundBySlug = toPairMap(cfg.backgroundItems, cfg.backgroundPrefix);

  const slugs = Array.from(new Set([...selectorBySlug.keys(), ...backgroundBySlug.keys()]))
    .sort((a, b) => a.localeCompare(b));

  const items = slugs
    .map((slug, idx) => {
      const selectorUrl = selectorBySlug.get(slug) || backgroundBySlug.get(slug) || null;
      const backgroundUrl = backgroundBySlug.get(slug) || selectorBySlug.get(slug) || null;
      return {
        id: cfg.idPrefix + String(idx + 1).padStart(2, '0'),
        slug,
        selectorUrl,
        backgroundUrl,
      };
    })
    .filter((item) => item.selectorUrl && item.backgroundUrl);

  return {
    id: cfg.id,
    label: cfg.label,
    items,
  };
}

const DECORATIVE_SELECTOR_ITEMS = [
  { file: 'newsfeed-bg-selector-archway-candy-clouds.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-archway-candy-clouds.jpg') },
  { file: 'newsfeed-bg-selector-baby-blue-confetti.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-baby-blue-confetti.jpg') },
  { file: 'newsfeed-bg-selector-blurry-hearts.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-blurry-hearts.jpg') },
  { file: 'newsfeed-bg-selector-bright-heart-mold.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-bright-heart-mold.jpg') },
  { file: 'newsfeed-bg-selector-bright-streaks.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-bright-streaks.jpg') },
  { file: 'newsfeed-bg-selector-concrete.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-concrete.jpg') },
  { file: 'newsfeed-bg-selector-cotton-candy-wave.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-cotton-candy-wave.jpg') },
  { file: 'newsfeed-bg-selector-dark-bokeh-rain.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-dark-bokeh-rain.jpg') },
  { file: 'newsfeed-bg-selector-gold-confetti.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-gold-confetti.jpg') },
  { file: 'newsfeed-bg-selector-haha.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-haha.jpg') },
  { file: 'newsfeed-bg-selector-light-colored-watermark-border.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-light-colored-watermark-border.jpg') },
  { file: 'newsfeed-bg-selector-light-purple-corner-stars.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-light-purple-corner-stars.jpg') },
  { file: 'newsfeed-bg-selector-light-textured-waves.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-light-textured-waves.jpg') },
  { file: 'newsfeed-bg-selector-lilac-purple-circles.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-lilac-purple-circles.jpg') },
  { file: 'newsfeed-bg-selector-mint-green-grid.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-mint-green-grid.jpg') },
  { file: 'newsfeed-bg-selector-night-sandunes.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-night-sandunes.jpg') },
  { file: 'newsfeed-bg-selector-pink-candy-hearts.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-pink-candy-hearts.jpg') },
  { file: 'newsfeed-bg-selector-red-water-blob.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-red-water-blob.jpg') },
  { file: 'newsfeed-bg-selector-rose-leather.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-rose-leather.jpg') },
  { file: 'newsfeed-bg-selector-saftey-green-oval.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-saftey-green-oval.jpg') },
  { file: 'newsfeed-bg-selector-sunshine-yellow-watermark.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-sunshine-yellow-watermark.jpg') },
  { file: 'newsfeed-bg-selector-yellow-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-SELECTOR/newsfeed-bg-selector-yellow-orange.jpg') },
];

const DECORATIVE_BG_ITEMS = [
  { file: 'newsfeed-bg-post-archway-candy-clouds.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-archway-candy-clouds.jpg') },
  { file: 'newsfeed-bg-post-baby-blue-confetti.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-baby-blue-confetti.jpg') },
  { file: 'newsfeed-bg-post-blurry-hearts.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-blurry-hearts.jpg') },
  { file: 'newsfeed-bg-post-bright-heart-mold.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-bright-heart-mold.jpg') },
  { file: 'newsfeed-bg-post-bright-streaks.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-bright-streaks.jpg') },
  { file: 'newsfeed-bg-post-concrete.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-concrete.jpg') },
  { file: 'newsfeed-bg-post-cotton-candy-wave.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-cotton-candy-wave.jpg') },
  { file: 'newsfeed-bg-post-dark-bokeh-rain.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-dark-bokeh-rain.jpg') },
  { file: 'newsfeed-bg-post-gold-confetti.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-gold-confetti.jpg') },
  { file: 'newsfeed-bg-post-haha.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-haha.jpg') },
  { file: 'newsfeed-bg-post-light-colored-watermark-border.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-light-colored-watermark-border.jpg') },
  { file: 'newsfeed-bg-post-light-purple-corner-stars.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-light-purple-corner-stars.jpg') },
  { file: 'newsfeed-bg-post-light-textured-waves.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-light-textured-waves.jpg') },
  { file: 'newsfeed-bg-post-lilac-purple-circles.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-lilac-purple-circles.jpg') },
  { file: 'newsfeed-bg-post-mint-green-grid.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-mint-green-grid.jpg') },
  { file: 'newsfeed-bg-post-night-sandunes.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-night-sandunes.jpg') },
  { file: 'newsfeed-bg-post-pink-candy-hearts.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-pink-candy-hearts.jpg') },
  { file: 'newsfeed-bg-post-red-water-blob.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-red-water-blob.jpg') },
  { file: 'newsfeed-bg-post-rose-leather.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-rose-leather.jpg') },
  { file: 'newsfeed-bg-post-safety-green-oval.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-safety-green-oval.jpg') },
  { file: 'newsfeed-bg-post-sunshine-yellow-watermark.jpg', url: require('../assets/media/images/pl-newsfeed-bg/DECORATIVE-BG/newsfeed-bg-post-sunshine-yellow-watermark.jpg') },
];

const GRADIENT_SELECTOR_ITEMS = [
  { file: 'newsfeed-bg-selector-gradient-blue-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-blue-purple.jpg') },
  { file: 'newsfeed-bg-selector-gradient-cotton-candy.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-cotton-candy.jpg') },
  { file: 'newsfeed-bg-selector-gradient-hot-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-hot-pink.jpg') },
  { file: 'newsfeed-bg-selector-gradient-light-bubles.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-light-bubles.jpg') },
  { file: 'newsfeed-bg-selector-gradient-pink-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-pink-blue.jpg') },
  { file: 'newsfeed-bg-selector-gradient-pink-to-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-pink-to-orange.jpg') },
  { file: 'newsfeed-bg-selector-gradient-red-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-red-purple.jpg') },
  { file: 'newsfeed-bg-selector-gradient-sand.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-sand.jpg') },
  { file: 'newsfeed-bg-selector-gradient-yellow-pink-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT_SELECTOR/newsfeed-bg-selector-gradient-yellow-pink-blue.jpg') },
];

const GRADIENT_BG_ITEMS = [
  { file: 'newsfeed-bg-post-gradient-blue-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-blue-purple.jpg') },
  { file: 'newsfeed-bg-post-gradient-cotton-candy.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-cotton-candy.jpg') },
  { file: 'newsfeed-bg-post-gradient-hot-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-hot-pink.jpg') },
  { file: 'newsfeed-bg-post-gradient-light-bubles.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-light-bubles.jpg') },
  { file: 'newsfeed-bg-post-gradient-pink-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-pink-blue.jpg') },
  { file: 'newsfeed-bg-post-gradient-pink-to-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-pink-to-orange.jpg') },
  { file: 'newsfeed-bg-post-gradient-red-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-red-purple.jpg') },
  { file: 'newsfeed-bg-post-gradient-sand.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-sand.jpg') },
  { file: 'newsfeed-bg-post-gradient-yellow-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-yellow-orange.jpg') },
  { file: 'newsfeed-bg-post-gradient-yellow-pink-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/GRADIENT-BG/newsfeed-bg-post-gradient-yellow-pink-blue.jpg') },
];

const SOLID_SELECTOR_ITEMS = [
  { file: 'newsfeed-bg-selector-dark-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-dark-teal.jpg') },
  { file: 'newsfeed-bg-selector-solid-baby-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-baby-blue.jpg') },
  { file: 'newsfeed-bg-selector-solid-black.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-black.jpg') },
  { file: 'newsfeed-bg-selector-solid-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-blue.jpg') },
  { file: 'newsfeed-bg-selector-solid-blush-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-blush-pink.jpg') },
  { file: 'newsfeed-bg-selector-solid-brick-red.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-brick-red.jpg') },
  { file: 'newsfeed-bg-selector-solid-brown.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-brown.jpg') },
  { file: 'newsfeed-bg-selector-solid-cream-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-cream-green.jpg') },
  { file: 'newsfeed-bg-selector-solid-dark-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-dark-blue.jpg') },
  { file: 'newsfeed-bg-selector-solid-dark-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-dark-purple.jpg') },
  { file: 'newsfeed-bg-selector-solid-evergreen.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-evergreen.jpg') },
  { file: 'newsfeed-bg-selector-solid-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-green.jpg') },
  { file: 'newsfeed-bg-selector-solid-grey.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-grey.jpg') },
  { file: 'newsfeed-bg-selector-solid-hot-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-hot-purple.jpg') },
  { file: 'newsfeed-bg-selector-solid-light-grey.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-light-grey.jpg') },
  { file: 'newsfeed-bg-selector-solid-light-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-light-pink.jpg') },
  { file: 'newsfeed-bg-selector-solid-light-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-light-purple.jpg') },
  { file: 'newsfeed-bg-selector-solid-light-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-light-teal.jpg') },
  { file: 'newsfeed-bg-selector-solid-light-yellow.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-light-yellow.jpg') },
  { file: 'newsfeed-bg-selector-solid-lime-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-lime-green.jpg') },
  { file: 'newsfeed-bg-selector-solid-mint-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-mint-green.jpg') },
  { file: 'newsfeed-bg-selector-solid-mustard.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-mustard.jpg') },
  { file: 'newsfeed-bg-selector-solid-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-orange.jpg') },
  { file: 'newsfeed-bg-selector-solid-pine-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-pine-green.jpg') },
  { file: 'newsfeed-bg-selector-solid-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-pink.jpg') },
  { file: 'newsfeed-bg-selector-solid-pinkish-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-pinkish-purple.jpg') },
  { file: 'newsfeed-bg-selector-solid-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-purple.jpg') },
  { file: 'newsfeed-bg-selector-solid-red.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-red.jpg') },
  { file: 'newsfeed-bg-selector-solid-rose.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-rose.jpg') },
  { file: 'newsfeed-bg-selector-solid-sand.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-sand.jpg') },
  { file: 'newsfeed-bg-selector-solid-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-teal.jpg') },
  { file: 'newsfeed-bg-selector-solid-yellow.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-SELECTOR/newsfeed-bg-selector-solid-yellow.jpg') },
];

const SOLID_BG_ITEMS = [
  { file: 'newsfeed-bg-post-dark-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-dark-teal.jpg') },
  { file: 'newsfeed-bg-post-solid-baby-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-baby-blue.jpg') },
  { file: 'newsfeed-bg-post-solid-black.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-black.jpg') },
  { file: 'newsfeed-bg-post-solid-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-blue.jpg') },
  { file: 'newsfeed-bg-post-solid-blush-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-blush-pink.jpg') },
  { file: 'newsfeed-bg-post-solid-brick-red.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-brick-red.jpg') },
  { file: 'newsfeed-bg-post-solid-brown.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-brown.jpg') },
  { file: 'newsfeed-bg-post-solid-cream-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-cream-green.jpg') },
  { file: 'newsfeed-bg-post-solid-dark-blue.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-dark-blue.jpg') },
  { file: 'newsfeed-bg-post-solid-dark-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-dark-purple.jpg') },
  { file: 'newsfeed-bg-post-solid-evergreen.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-evergreen.jpg') },
  { file: 'newsfeed-bg-post-solid-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-green.jpg') },
  { file: 'newsfeed-bg-post-solid-grey.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-grey.jpg') },
  { file: 'newsfeed-bg-post-solid-hot-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-hot-purple.jpg') },
  { file: 'newsfeed-bg-post-solid-light-grey.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-light-grey.jpg') },
  { file: 'newsfeed-bg-post-solid-light-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-light-pink.jpg') },
  { file: 'newsfeed-bg-post-solid-light-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-light-purple.jpg') },
  { file: 'newsfeed-bg-post-solid-light-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-light-teal.jpg') },
  { file: 'newsfeed-bg-post-solid-light-yellow.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-light-yellow.jpg') },
  { file: 'newsfeed-bg-post-solid-lime-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-lime-green.jpg') },
  { file: 'newsfeed-bg-post-solid-mint-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-mint-green.jpg') },
  { file: 'newsfeed-bg-post-solid-mustard.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-mustard.jpg') },
  { file: 'newsfeed-bg-post-solid-orange.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-orange.jpg') },
  { file: 'newsfeed-bg-post-solid-pine-green.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-pine-green.jpg') },
  { file: 'newsfeed-bg-post-solid-pink.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-pink.jpg') },
  { file: 'newsfeed-bg-post-solid-pinkish-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-pinkish-purple.jpg') },
  { file: 'newsfeed-bg-post-solid-purple.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-purple.jpg') },
  { file: 'newsfeed-bg-post-solid-red.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-red.jpg') },
  { file: 'newsfeed-bg-post-solid-rose.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-rose.jpg') },
  { file: 'newsfeed-bg-post-solid-sand.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-sand.jpg') },
  { file: 'newsfeed-bg-post-solid-teal.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-teal.jpg') },
  { file: 'newsfeed-bg-post-solid-yellow.jpg', url: require('../assets/media/images/pl-newsfeed-bg/SOLID-BG/newsfeed-bg-post-solid-yellow.jpg') },
];

export const NEWSFEED_BACKGROUND_GROUPS = [
  buildGroup({
    id: 'decorative',
    label: 'Decorative',
    idPrefix: 'dec_',
    selectorPrefix: 'newsfeed-bg-selector-',
    backgroundPrefix: 'newsfeed-bg-post-',
    selectorItems: DECORATIVE_SELECTOR_ITEMS,
    backgroundItems: DECORATIVE_BG_ITEMS,
  }),
  buildGroup({
    id: 'gradient',
    label: 'Gradient',
    idPrefix: 'grd_',
    selectorPrefix: 'newsfeed-bg-selector-',
    backgroundPrefix: 'newsfeed-bg-post-',
    selectorItems: GRADIENT_SELECTOR_ITEMS,
    backgroundItems: GRADIENT_BG_ITEMS,
  }),
  buildGroup({
    id: 'solid',
    label: 'Solid',
    idPrefix: 'sld_',
    selectorPrefix: 'newsfeed-bg-selector-',
    backgroundPrefix: 'newsfeed-bg-post-',
    selectorItems: SOLID_SELECTOR_ITEMS,
    backgroundItems: SOLID_BG_ITEMS,
  }),
];

const BACKGROUND_BY_ID = NEWSFEED_BACKGROUND_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.id] = item;
  });
  return acc;
}, {});

const DARK_HINTS = [
  'dark',
  'night',
  'black',
  'evergreen',
  'pine',
  'brown',
  'brick',
  'purple',
  'teal',
  'red',
  'blue',
];

export function guessNewsfeedBackgroundTone(url) {
  const src = String(url || '').toLowerCase();
  if (DARK_HINTS.some((hint) => src.includes(hint))) return 'dark';
  return 'light';
}

const toneCache = new Map();

export function detectNewsfeedBackgroundTone(url) {
  const src = String(url || '').trim();
  if (!src) return Promise.resolve('dark');
  if (toneCache.has(src)) return Promise.resolve(toneCache.get(src));
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    const guessed = guessNewsfeedBackgroundTone(src);
    toneCache.set(src, guessed);
    return Promise.resolve(guessed);
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const w = 24;
        const h = 24;
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('No 2d context');

        ctx.drawImage(img, 0, 0, w, h);
        const pixels = ctx.getImageData(0, 0, w, h).data;

        let total = 0;
        let count = 0;
        for (let i = 0; i < pixels.length; i += 4) {
          const alpha = pixels[i + 3];
          if (alpha < 8) continue;
          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];
          const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          total += luma;
          count += 1;
        }

        const avg = count ? total / count : 0;
        const tone = avg >= 155 ? 'light' : 'dark';
        toneCache.set(src, tone);
        resolve(tone);
      } catch (_) {
        const guessed = guessNewsfeedBackgroundTone(src);
        toneCache.set(src, guessed);
        resolve(guessed);
      }
    };

    img.onerror = () => {
      const guessed = guessNewsfeedBackgroundTone(src);
      toneCache.set(src, guessed);
      resolve(guessed);
    };

    img.src = src;
  });
}

export function getNewsfeedBackgroundById(id) {
  if (!id) return null;
  return BACKGROUND_BY_ID[String(id)] || null;
}
